<template>
  <el-form ref="form" :model="acountForm" label-width="140px" class="set-acount">
    <el-form-item label="呼入号码：">
      <el-input v-model="acountForm.school_tel" placeholder="请输入呼叫号码"></el-input>
    </el-form-item>
    <el-form-item label="拾音等待时长：">
      <el-input-number v-model="acountForm.wait_time" :min="1"></el-input-number>
    </el-form-item>
    <el-form-item label="呼入并发数：">
      <el-input-number v-model="acountForm.concurrent" :min="1"></el-input-number>
    </el-form-item>
    <el-form-item label="是否开启铃声：">
      <el-switch :active-value="2" :inactive-value="1" active-color="#409eff" v-model="acountForm.has_ring"></el-switch>
    </el-form-item>
    <upload-audio :audio.sync="acountForm.rings" ring v-show="acountForm.has_ring == 2"></upload-audio>
    <el-form-item label="转人工号码：">
      <el-input v-model="acountForm.phone" placeholder="请输入转人工号码"></el-input>
      <div class="tips">多个号码用@连接</div>
    </el-form-item>
    <el-form-item label="显示通话详情：">
      <el-radio-group v-model="acountForm.is_see">
        <el-radio :label="2">是</el-radio>
        <el-radio :label="1">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-button type="three" @click="onSubmit">保存</el-button>
  </el-form>
</template>

<script>
import { isSuccess, getCompletionUrl } from '@/utils/index'
import { getAccountDetail, saveAccountDetail } from '@/api/setBase'
export default {
  components: {
    'upload-audio': () => import('@/components/uploadAudio/index.vue'),
  },
  data() {
    return {
      acountForm: {
        school_tel: '',
        wait_time: 1,
        concurrent: 1,
        customer_tel: [],
        rings: '',
        has_ring: 1,
        phone: '',
        is_see: 2
      },
    }
  },
  mounted() {
    this.getObject()
  },
  methods: {
    async getObject() {
      const res = await getAccountDetail()
      if (res.data != null) {
        this.acountForm = {
          id: res.data.id,
          school_tel: res.data.school_tel,
          wait_time: res.data.wait_time,
          concurrent: res.data.concurrent,
          customer_tel: [],
          rings: res.data.rings,
          has_ring: res.data.has_ring,
          phone: res.data.phone,
          is_see: res.data.is_see || 2
        }
      }
    },
    handleAvatarSuccess(res, file) {
      this.acountForm.robot_pic = getCompletionUrl(res.data.file)
    },
    async onSubmit() {
      const res = await saveAccountDetail(this.acountForm)
      if (isSuccess(res.code)) {
        this.$message.success('保存成功')
      }
    },
  },
}
</script>

<style lang="scss">
.set-acount {
  .el-input {
    width: 100%;
    max-width: 300px;
  }

  .add-input {
    max-width: 300px;
    text-align: center;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    box-sizing: border-box;
  }

  .input-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .my-delete:before {
    margin-left: 10px;
    font-size: 30px;
    color: red;
  }

  .avatar-uploader {
    .el-icon-plus:before {
      line-height: 100px;
    }
  }

  .el-select:nth-child(2) {
    margin: 0 10px;
    width: 110px;
  }

  .el-select:last-child {
    width: 264px;
  }
}
</style>
